import { ToastMessagesServiceBase } from 'Angular/features/components/toast-messages/toast-messages-service-base';
import * as i0 from "@angular/core";
/**
 * Service to manage creating and removing messages displayed by ToastMessagesComponent.
 */
export class PageToastMessagesService extends ToastMessagesServiceBase {
}
PageToastMessagesService.ɵfac = /*@__PURE__*/ (() => { let ɵPageToastMessagesService_BaseFactory; return function PageToastMessagesService_Factory(__ngFactoryType__) { return (ɵPageToastMessagesService_BaseFactory || (ɵPageToastMessagesService_BaseFactory = i0.ɵɵgetInheritedFactory(PageToastMessagesService)))(__ngFactoryType__ || PageToastMessagesService); }; })();
PageToastMessagesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PageToastMessagesService, factory: PageToastMessagesService.ɵfac, providedIn: 'root' });
